<template>
  <div class="help-block" :class="{open: dropdownOpen || videoOpen}" @click.self="closeVideo" v-if="showHints">
    <div class="help-icon help-item" @click="dropdownOpen = true">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.6672 30.0001C21.6672 30.9205 20.921 31.6667 20.0006 31.6667C19.0801 31.6667 18.334 30.9205 18.334 30.0001C18.334 29.0797 19.0801 28.3335 20.0006 28.3335C20.921 28.3335 21.6672 29.0797 21.6672 30.0001Z" fill="#7D6AED"/>
        <path d="M20.0002 40C8.97167 40 0 31.0283 0 19.9998C0 8.97118 8.97167 -0.000488281 20.0002 -0.000488281C31.0288 -0.000488281 40.0005 8.97118 40.0005 19.9998C40.0005 31.0283 31.0288 40 20.0002 40ZM20.0002 2.49954C10.3502 2.49954 2.50003 10.3497 2.50003 19.9998C2.50003 29.6498 10.3502 37.5 20.0002 37.5C29.6503 37.5 37.5005 29.6498 37.5005 19.9998C37.5005 10.3497 29.6503 2.49954 20.0002 2.49954Z" fill="#7D6AED"/>
        <path d="M20.0015 24.5836C19.3115 24.5836 18.7515 24.0236 18.7515 23.3336V21.6502C18.7515 20.0636 19.7583 18.6418 21.2549 18.1135C23.2465 17.4119 24.585 15.29 24.585 13.75C24.585 11.2216 22.5299 9.16654 20.0015 9.16654C17.4731 9.16654 15.418 11.2216 15.418 13.75C15.418 14.44 14.858 15 14.168 15C13.478 15 12.918 14.44 12.918 13.75C12.918 9.84495 16.0949 6.6665 20.0015 6.6665C23.9081 6.6665 27.085 9.84495 27.085 13.75C27.085 16.5302 24.8899 19.4819 22.0865 20.4719C21.5866 20.6468 21.2515 21.1216 21.2515 21.6517V23.3336C21.2515 24.0236 20.6915 24.5836 20.0015 24.5836Z" fill="#7D6AED"/>
      </svg>
    </div>
    <div class="help-dropdown help-item" :class="{open: dropdownOpen}">
      <ul class="help-list">
        <li><a href="#" @click.prevent="videoOpen = true">{{$lang.messages.hints.hiw}}</a></li>
        <li><a href="https://kidsmode.net/#faq" target="_blank">{{$lang.messages.hints.faq}}</a></li>
        <li><a href="https://kidsmode.net/contact" target="_blank">{{$lang.messages.hints.contact}}</a></li>
        <li><a href="https://kidsmode.net/terms" target="_blank">{{$lang.messages.hints.terms_privacy}}</a></li>
        <li @click="showHints = false">{{$lang.messages.hints.hide}}</li>
        <li class="text-right p-0" @click="dropdownOpen = false; videoOpen = false"><i class="icon-close"></i></li>
      </ul>
    </div>
    <div class="help-video help-item" :class="{open: videoOpen}">
      <iframe ref="video" width="100%" height="100%" src="https://www.youtube.com/embed/ayYbjLD32Ag?enablejsapi=1&version=3&playerapiid=ytplayer" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <div @click="closeVideo" class="text-right"><i class="icon-close"></i></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Help',
  props: ['videoIsOpen'],
  data: function (){
    return {
      showHints: true,
      dropdownOpen: false,
      videoOpen: this.videoIsOpen,
    }
  },
  methods: {
    closeVideo () {
      this.$refs.video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      this.videoOpen = false;
      this.dropdownOpen=false
      if(!localStorage.getItem('tutorialVideoShowed')) {
        localStorage.setItem('tutorialVideoShowed', true)
      }
    }
  },
}

</script>

<style lang="scss">
@import "@/assets/styles/helpers";


  .help {
    &-item {
      background: #FFFFFF;
      box-shadow: 0px 91.4286px 73.1429px rgba(0, 0, 0, 0.07), 0px 38.1967px 30.5573px rgba(0, 0, 0, 0.0503198), 0px 20.4218px 16.3374px rgba(0, 0, 0, 0.0417275), 0px 11.4483px 9.15862px rgba(0, 0, 0, 0.035), 0px 6.08009px 4.86407px rgba(0, 0, 0, 0.0282725), 0px 2.53006px 2.02405px rgba(0, 0, 0, 0.0196802);
      border-radius: 14.6286px;
      padding: 15px;
    }


    &-icon {
      position: absolute;
      right: 0;
      bottom: 0;
      cursor: pointer;

      @include responsive-below($sm){
        left: 0;
        right: auto;
        width: 44px;
        height: 44px;
        padding: 10px;

        svg {
          max-width: 100%;
          height: auto;
        }
      }

      &:before {
        content: "";
        width: 16px;
        height: 16px;
        background: #FF5C5C;
        position: absolute;
        right: -5px;
        top: -5px;
        border-radius: 50%;

        @include responsive-below($sm){
          width: 10px;
          height: 10px;
          top: 0;
          right: 0;
        }
      }

      svg {
        display: block;
      }
    }

    &-block {
      padding: 15px;
      position: fixed;
      bottom: 25px;
      right: 35px;
      z-index: 10;

      &.open {
        width: 100vw;
        height: 100vh;
        background: transparent;
      }

      @include responsive-below($sm){
        left: 15px;
        bottom: 70px;
        right: auto;
      }
    }

    &-dropdown {
      min-width: 260px;
      position: absolute;
      right: 0;
      bottom: 0;
      transition: all 0.3s;
      transform: scale(0);
      transform-origin: 100% 100%;

      @include responsive-below($sm){
        left: 0;
        right: auto;
        transform-origin: 0 100%;
      }

      &.open {
        transform: none;
      }
    }

    &-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        padding: 10px 0;
        cursor: pointer;
      }
      
      a {
        color: #0e0e0e;
        
        &:hover {
          text-decoration: underline;
        }
      }
    }

    &-video {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 50vw;
      height: 50vh;
      padding-bottom: 50px;
      transform: scale(0);
      transform-origin: 100% 100%;
      transition: all 0.3s;
      overflow: hidden;

      @include responsive-below($xs){
        left: 0;
        right: auto;
        transform-origin: 0 100%;
      }

      @include responsive-below($md){
        width: calc(100vw - 50px);
      }

      iframe {
        margin-bottom: 10px;
      }

      &.open {
        transform: none;
      }

      .icon-close {
        cursor: pointer;
      }
    }
  }
</style>
